/**
 * Legacy imperative engine bridge.
 *
 * `cm2Engine` and `heroControls` are the original landing-page engine — they
 * drive the cost-model animation and hero controls via direct DOM
 * manipulation. They are untyped legacy modules (`@ts-nocheck`) invoked once
 * here; they are NOT React. Only the conversion form (HeroConversionModal) is
 * React-native. The engine talks to React through a small set of `window`
 * globals: `openHeroConversionModal` (React → open the form) and `MuirLead`
 * (engine's own inline email gates → React lead handler).
 */
import type { LeadPayload } from '~/widgets/CostBomDemo/hooks/useCostModelLead'

import { initCm2Engine } from '~/widgets/CostBomDemo/engine/cm2Engine'
import { initHeroControls } from '~/widgets/CostBomDemo/engine/heroControls'
import { mountBomPanels } from '~/widgets/CostBomDemo/engine/mountBomPanels'

export interface LegacyEngineOptions {
  root: HTMLElement
  productImages: Record<string, string>
  onLead: (lead: LeadPayload) => void
}

let engineInitialized = false

export function runLegacyEngine({
  root,
  productImages,
  onLead,
}: LegacyEngineOptions) {
  if (engineInitialized) return
  engineInitialized = true

  // eslint-disable-next-line no-underscore-dangle
  window.__COST_BOM_PRODUCT_IMAGES__ = productImages
  window.MuirLead = (lead) => {
    onLead({
      email: lead.email,
      product: lead.product,
      country: lead.country,
      source: lead.source as LeadPayload['source'],
    })
  }

  mountBomPanels(root)
  initCm2Engine()
  initHeroControls()
}

export function resetLegacyEngine() {
  engineInitialized = false
}

declare global {
  interface Window {
    __COST_BOM_PRODUCT_IMAGES__?: Record<string, string>
    MuirLead?: (lead: {
      email: string
      product: string
      country: string
      source: string
    }) => void
    openHeroConversionModal?: () => void
  }
}
